import React from 'react';
import { GuideDataType } from '../Gude.types';
import styles from './Instruction.module.css';
import { ReactComponent as FloikLogo } from '../../../../../Common/images/floik-logo-grey.svg';
import { APP_WEBSITE_URL } from '../../../../../Common/Common.env';
import classNames from 'classnames';
import { getContrastColor, sanitizeHtml } from '../../../../../Common/Common.utils';
import { enablePoweredBYSelector } from '../../../../../Common/Common.selector';
import { useSelector } from 'react-redux';

export default function Steps({
	steps,
	hideHeader,
	themeColor,
	internalArticles,
	onPoweredByClick,
}: {
	steps: GuideDataType[];
	hideHeader?: boolean;
	internalArticles?: boolean;
	themeColor?: string;
	onPoweredByClick(): void;
}) {
	const showPoweredBy = useSelector(enablePoweredBYSelector);
	return (
		<div className={styles.steps}>
			<div
				className={styles.stepHeading}
				style={{
					color: getContrastColor(themeColor),
				}}
			>
				Table of contents
			</div>
			<ul
				className={classNames(styles['steps-list'], 'font-14 grey-color', {
					[styles['no-header']]: hideHeader && !internalArticles,
				})}
			>
				{steps.map((step: GuideDataType, index: number) => {
					return (
						<li
							id={index.toString()}
							key={index}
							className="flex hr-space-between"
							style={{
								color: getContrastColor(themeColor),
							}}
							onClick={() => {
								const elem = document.getElementById(`step-${step.id}`);
								if (elem) {
									elem.scrollIntoView({
										behavior: 'smooth',
									});
								}
							}}
						>
							<div className={classNames(styles.content, 'flex hr-space-between')}>
								<div className={classNames(styles.index, 'rubik-medium')}>
									{index + 1}.
								</div>
								<div className={classNames(styles['step-name'], 'text-ellipsis')}>
									<div
										style={{
											color: getContrastColor(themeColor),
										}}
										className={styles.title}
										contentEditable={false}
										dangerouslySetInnerHTML={{ __html: sanitizeHtml(step.title) }}
									/>
								</div>
							</div>
						</li>
					);
				})}
			</ul>
			{showPoweredBy && (
				<div className={styles.poweredby}>
					<a
						href={APP_WEBSITE_URL}
						target="_blank"
						className={styles.link}
						onClick={onPoweredByClick}
					>
						Powered by
						<FloikLogo className={styles.floikSVGIcon} />
					</a>
				</div>
			)}
		</div>
	);
}
